import Mutations from "./dashboard-mutations";
import Actions from "./dashboard-actions";
import Getters from "./dashboard-getters";
const DashboardStore = {
  namespaced: true,
  state: {
    clientActivity: {
      byId: {},
      allIds: []
    }
  },
  mutations: Mutations,
  actions: Actions,
  getters: Getters
};
export default DashboardStore;